import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Operator, RelationalLogicalOperator } from '../../../dataModels/grid-list';

@Component({
    moduleId: module.id,
    selector: 'search-list',
    templateUrl: 'search-list.component.html'
})
export class SearchList {

    @Input() fieldList: string[] = [];

    @Input() displayName: string;
    @Input() operator: Operator;

    @Input() relationOperator: RelationalLogicalOperator;

    @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

    @Output() clearEvent: EventEmitter<string> = new EventEmitter<string>();

    searchValue: string;

    onSearch() {

        this.valueChange.emit(this.searchValue);
    }

    onClear() {

        this.searchValue = null;
        this.clearEvent.emit(this.searchValue);
    }

    onTextEmpty(): void {
        if (this.searchValue == "")
            this.onClear();
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/listView/searchList/search-list.component.ts